if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();

      // Écouter l'événement 'pageshow' pour rafraîchir le panier en cas de restauration depuis le cache
      /* window.addEventListener('pageshow', this.handlePageShow.bind(this)); */
    }


    // connectedCallback() {
    //   // Vérifie si la checkbox existe et attache l'écouteur d'événement
    //     this.shippingCheckbox = document.getElementById('shipping-protection');
    //     this.checkoutBtn = document.querySelector('.proceed-to-checkout');

    //     if (this.checkoutBtn) {
    //       this.checkoutBtn.addEventListener('click', this.handleCheckout.bind(this));
    //     }
      
    //     if (this.shippingCheckbox) {
    //       console.log("Checkbox trouvée, ajout de l'EventListener.");
    //       // Utilisez une fonction fléchée pour préserver la portée de `this`
    //       this.shippingCheckbox.addEventListener('change', (event) => this.handleCheckboxChange(event));
          
    //       // Initialisez l'état du panier selon l'état de la checkbox
    //       this.initializeCartWithCheckbox();
    //     } else {
    //       console.log("La checkbox 'shipping-protection' n'a pas été trouvée dans le DOM.");
    //     }
    // }


        /**
     * Initialise l'état du panier selon l'état actuel de la checkbox
     */
    // async initializeCartWithCheckbox() {
    //   const productVariantId = 49887609913664; // Remplacez par l'ID de la variante

    //   try {
    //     const isCheckboxChecked = await this.getFromLocalStorage("shipping-protection");
    //     if (isCheckboxChecked === 1) {
    //       console.log('La checkbox est cochée au chargement, ajout du produit au panier...');
    //       await this.addProductToCart(productVariantId);
    //     } else if ((isCheckboxChecked === 0)) {
    //       if (this.isProductInCart(productVariantId)) {
    //         await this.removeProductFromCart(productVariantId);
    //       }
    //     } else {
    //       await this.saveToLocalStorage("shipping-protection", 1);
    //     }
    //   } catch (error) {
    //     console.error('Erreur lors de l\'initialisation du panier avec la checkbox :', error);
    //   }
    // }



    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');
        // this.checkoutBtn = document.querySelector('.proceed-to-checkout'); // Bouton pour procéder au paiement
        
        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
    
        // if (this.checkoutBtn) {
        //   this.checkoutBtn.addEventListener('click', this.handleCheckout.bind(this));
        // }
      }
    }


    
    /**
     * Gère le changement d'état de la checkbox.
     * Ajoute ou supprime le produit du panier en fonction de son état.
     */
    // async handleCheckboxChange(event) {
    //   const productVariantId = 49887609913664; // Remplacez par l'ID de la variante
    //   console.log("Clique détecté sur la checkbox");
    //   try {
    //     if (event.target.checked) {
    //       console.log('Checkbox cochée, ajout du produit...');
    //       await this.saveToLocalStorage("shipping-protection", 1);
    //       const quantity = await this.isProductInCart(productVariantId);
    //        if (quantity === 0) {
    //         await this.addProductToCart(productVariantId);
    //       }
    //     } else {
    //       console.log('Checkbox décochée, suppression du produit...');
    //       await this.saveToLocalStorage("shipping-protection", 0);
    //       await this.removeProductFromCart(productVariantId);
    //     }

    //     const cartItems = document.querySelector('cart-items');
    //     if (cartItems && cartItems.refresh) {
    //       console.log('Rafraîchissement du panier...');
    //       await cartItems.refresh();
    //     }
    //   } catch (error) {
    //     console.error('Erreur lors de la gestion de la checkbox :', error);
    //   }
    // }




    // /**
    //  * Handles the checkout button click.
    //  * Adds product if the checkbox is checked, then proceeds to checkout.
    //  * @param {object} evt - Event object.
    //  */
    // async handleCheckout(evt) {
    //   evt.preventDefault(); 
    //   /* console.log("aller au checkout"); */
    //   const productVariantId = 49887609913664; // Remplacez par l'ID de la variante
    //   const quantity = await this.isProductInCart(productVariantId);

    //   // Vérifier si la checkbox est cochée
    //   const checkbox = document.querySelector('#shipping-protection');
    //   if (quantity === 0 && checkbox && checkbox.checked) {
    //     console.log('Shipping protection selected. Adding product to cart...');
    //     try {
    //       await this.addProductToCart(productVariantId); // Ajouter le produit
    //     } catch (error) {
    //       console.error('Erreur lors de l'ajout du produit au panier:', error);
    //       return; // Arrêter ici en cas d'échec
    //     }
    //   } else if (quantity > 1) {
    //     await this.removeProductFromCart(productVariantId);
    //     await this.addProductToCart(productVariantId);
    //   }

    //   this.deleteFromLocalStorage("shipping-protection");

    //   // Continuer avec la redirection existante vers le checkout
    //   console.log('Redirecting to checkout...');
    //   window.location.href = '/checkout';
    // }




    // /**
    //  * Vérifie si le produit est déjà dans le panier
    //  * @param {number} productVariantId - ID de la variante du produit à vérifier.
    //  * @returns {boolean} - Renvoie `true` si le produit est déjà dans le panier.
    //  */
    // async isProductInCart(productVariantId) {
    //   try {
    //     const response = await fetch('/cart.js');
    //     if (!response.ok) {
    //       throw new Error('Impossible de récupérer les données du panier');
    //     }

    //     const cartData = await response.json();

    //     const product = cartData.items.find(item => item.variant_id === productVariantId);

    //     // Si le produit est trouvé, retourne sa quantité, sinon retourne 0
    //     return product ? product.quantity : 0;
    //   } catch (error) {
    //     console.error(error.message);
    //     return 0; // Retourne 0 en cas d'erreur pour rester cohérent
    //   }
    // }




    //     /**
    //  * Supprime un produit du panier en utilisant son ID de variante.
    //  * @param {number} productVariantId - ID de la variante du produit à supprimer.
    //  */
    // async removeProductFromCart(productVariantId) {
    //   console.log('Suppression du produit du panier...');
    //   const response = await fetch('/cart/change.js', {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify({
    //       id: `${productVariantId}`,
    //       quantity: 0, // Quantité 0 signifie suppression
    //     }),
    //   });

    //   if (!response.ok) {
    //     throw new Error('Erreur lors de la suppression du produit du panier');
    //   }

    //   const data = await response.json();
    //   /* console.log('Produit supprimé du panier :', data); */
    //   /* window.location.reload(); */
    //   const cartItems = document.querySelector('cart-items');
    //   if (cartItems && cartItems.refresh) {
    //     await cartItems.refresh();
    //   }
    //   return data;
    // }


    

    // /**
    //  * Ajoute un produit au panier s'il n'est pas déjà présent
    //  * @param {number} productVariantId - ID de la variante du produit à ajouter.
    //  */
    // async addProductToCart(productVariantId) {
    //   const isInCart = await this.isProductInCart(productVariantId);

    //   if (isInCart) {
    //     /* console.log('Le produit est déjà dans le panier, aucun ajout nécessaire.'); */
    //     return;
    //   }

    //   console.log('Ajout du produit au panier...');
    //   const response = await fetch('/cart/add.js', {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify({
    //       id: productVariantId,
    //       quantity: 1,
    //     }),
    //   });

    //   if (!response.ok) {
    //     throw new Error('Erreur lors de l'ajout au panier');
    //   }

    //   const data = await response.json();
    //   /* console.log('Produit ajouté au panier :', data); */
    //   /* window.location.reload(); */
    //   const cartItems = document.querySelector('cart-items');
    //   if (cartItems && cartItems.refresh) {
    //     await cartItems.refresh();
    //   }
    //   return data;
    // }



    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();
      console.log("handleSubmit !");

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      try {
        const taxInput = this.form.querySelector('#tax-id-input');

        if (taxInput && taxInput.value && taxInput.value !== 'no_tax_product') {
          const mainProductQuantity = formData.get('quantity') || 1;

          formData.append('items[][id]', taxInput.value);
          formData.append('items[][quantity]', mainProductQuantity);
          formData.append(`items[][properties][${window.theme.strings.taxForAttribute}]`, taxInput.dataset.productTitle);
          formData.append('items[][properties][_tax_for]', taxInput.dataset.productId);
        }

        // Check if shipping protection is already in the cart
        const shippingProtectionVariantId = '49887609913664';
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();
        const shippingProtectionInCart = cartData.items.some(item => item.variant_id.toString() === shippingProtectionVariantId);

        // Add shipping protection to form data if not in cart
        if (!shippingProtectionInCart) {
          formData.append('items[][id]', shippingProtectionVariantId);
          formData.append('items[][quantity]', 1);
        }

        const fetchRequestOpts = {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        };

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          // setTimeout(() => {
            window.location.href = theme.routes.cart;
          // }, 300);
        } else {
          ProductForm.updateCartIcon(data);

          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          // setTimeout(() => {
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              ).then(() => {
                window.updateProductPageQuantity(data.variant_id);
              });
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          // }, 300);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }



    // // Fonction pour enregistrer une donnée dans le localStorage
    // async saveToLocalStorage(key, value) {
    //     // Convertir la valeur en JSON pour la stocker correctement
    //     const jsonData = JSON.stringify(value);
    //     localStorage.setItem(key, jsonData);
    //     console.log(`Donnée sauvegardée: ${key} ->`, value);
    // }
    
    // // Fonction pour récupérer une donnée du localStorage
    // async getFromLocalStorage(key) {
    //     // Récupérer la donnée sous forme de string JSON
    //     const jsonData = localStorage.getItem(key);
    //     // Si la donnée n'existe pas, retourner null
    //     if (!jsonData) {
    //         console.log(`Aucune donnée trouvée pour la clé "${key}"`);
    //         return null;
    //     }
    //     // Convertir la donnée JSON en objet ou autre type JavaScript
    //     const data = JSON.parse(jsonData);
    //     console.log(`Donnée récupérée: ${key} ->`, data);
    //     return data;
    // }
    
    // // Fonction pour supprimer une donnée du localStorage
    // async deleteFromLocalStorage(key) {
    //     localStorage.removeItem(key);
    //     console.log(`Donnée supprimée pour la clé "${key}"`);
    // }

    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}


